export function useValidacao() {
    const isEmailValido = (email: string) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }

    const isUrlValido = (value: string) => {
        try {
            const url = new URL(value);
            return url.protocol === 'http:' || url.protocol === 'https:';
        } catch (error) {
            return false;
        }
    }

    return {
        isEmailValido: isEmailValido,
        isUrlValido: isUrlValido
    }
}